import { Link } from 'react-router-dom';
import { getFormUrl } from '@/utils/formUtils';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold font-heading text-white">91视频</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              免费在线观看最新电影、热门电视剧、精彩综艺节目的优质平台。高清画质，流畅播放，每日更新。
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">视频分类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/movie" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">电影</Link></li>
              <li><Link to="/category/tv" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">电视剧</Link></li>
              <li><Link to="/category/variety" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">综艺</Link></li>
              <li><Link to="/category/anime" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">动漫</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">品牌介绍</Link></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">服务条款</a></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a></li>
              <li><a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">版权声明</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line"></i>
                </span>
                contact@91video.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line"></i>
                </span>
                400-123-4567
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line"></i>
                </span>
                北京市朝阳区望京科技园A座
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800/30 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2018-2026 91视频 All Rights Reserved. 本站所有视频均来自互联网，仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800/30 hover:bg-primary-500/80 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-sm text-foreground-300"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800/30 hover:bg-primary-500/80 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-sm text-foreground-300"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}